import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from '../../styles/styles.js';

const CardContent = (props) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.root, props.className)}>
      {props.children}
    </div>
  )
};

const useStyles = styles.makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
      padding: theme.spacing(2),
    }
  })
);

CardContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
}

export default CardContent;
